/* ========================================================================
   Breakpoints
 ========================================================================== */

var breakpoint_sm = '(min-width: 576px)';
var breakpoint_md = '(min-width: 768px)';
var breakpoint_lg = '(min-width: 992px)';
var breakpoint_xl = '(min-width: 1200px)';
var breakpoint_xxl = '(min-width: 1400px)';

var breakpoint_xs_max = '(max-width: 575.98px)';
var breakpoint_sm_max = '(max-width: 767.98px)';
var breakpoint_md_max = '(max-width: 991.98px)';
var breakpoint_lg_max = '(max-width: 1199.98px)';
var breakpoint_xl_max = '(max-width: 1399.98px)';

/* ========================================================================
    Polyfills
  ========================================================================== */

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

/* ========================================================================
    Utilities
  ========================================================================== */

const util = {
  frontEndVersion: '1',
  debugMode: false,
  uiCulture: null,
  uiLanguage: null,
  homePageId: null,
  path: null,

  getVersionedUrl: function (url) {
    return url + '?cdv=' + this.frontEndVersion;
  },

  onDocumentReady: function (callback) {
    const isReady = document.readyState != null && document.readyState != 'loading';

    if (isReady) {
      callback();
    } else {
      document.addEventListener('DOMContentLoaded', callback);
    }
  },

  endsWith: function (str, lookup) {
    return str.indexOf(lookup, str.length - lookup.length) !== -1;
  },

  startsWith: function (str, lookup) {
    return str.indexOf(lookup) === 0;
  },

  // http://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
  escapeRegExp: function (str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
  },

  // hasClass: function (element, selector) {
  //   let s = ' ';
  //   return (
  //     element.nodeType === 1 &&
  //     (s + element.className + s)
  //       .replace(/[\n\t]/g, s)
  //       .indexOf(s + selector + s) >= 0
  //   );
  // },

  // addClass: function (element, className) {
  //   if (this.hasClass(element, className) === false) {
  //     element.className += ' ' + className;
  //   }
  // },

  // removeClass: function (element, className) {
  //   const regex = new RegExp(
  //     '[\\b|\\s]*' + this.escapeRegExp(className) + '[\\b|\\s]*',
  //     'gi'
  //   );
  //   element.className = element.className.replace(regex, '');
  // },

  //isValidEmail: function (email) {
  //  if (!email) return false;

  //  return /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]{2,})+$/.test(email);
  //},

  getCookie: function (name) {
    let value = '; ' + document.cookie;
    let parts = value.split('; ' + name + '=');
    return parts.length !== 2 ? undefined : parts.pop().split(';').shift();
  },

  setCookie: function (name, value, expiryDays, domain, path) {
    let expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + (expiryDays || 365));

    let cookie = [
      name + '=' + value,
      'Expires=' + expirationDate.toUTCString(),
      'Path=' + (path || '/'),
      'SameSite=Lax',
    ];

    if (domain) {
      cookie.push('Domain=' + domain);
    }

    document.cookie = cookie.join(';');
  },

  deleteCookie: function (name) {
    this.setCookie(name, '', -1);
  },

  deepExtend: function () {
    let extended =
      Object.assign ||
      function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

    return extended.apply(this, arguments);
  },

  isPlainObject: function (obj) {
    // The code "typeof obj === 'object' && obj !== null" allows Array objects
    return typeof obj === 'object' && obj !== null && obj.constructor === Object;
  },

  isMobile: function () {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  },

  isIE: function () {
    // MSIE used to detect old browsers and Trident used to newer ones
    return navigator.userAgent.indexOf('MSIE ') > -1 || navigator.userAgent.indexOf('Trident/') > -1;
  },

  isEdge: function () {
    return navigator.userAgent.indexOf('Edge/') > -1;
  },

  getQueryString: function (name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regexS = '[\\?&]' + name + '=([^&#]*)';
    const regex = new RegExp(regexS);
    let results = regex.exec(window.location.href);
    if (results === null) {
      return '';
    } else {
      return results[1];
    }
  },

  getAnchor: function () {
    const urlParts = document.URL.split('#');
    return urlParts.length > 1 ? urlParts[1] : null;
  },

  // sortSelect: function (el, sortVal) {
  //   sortVal = sortVal || 'text';

  //   // Checks for an object or string. Uses string as ID.
  //   switch (typeof el) {
  //     case 'string':
  //       el = document.getElementById(el);
  //       break;
  //     case 'object':
  //       if (el == null) return false;
  //       break;
  //     default:
  //       return false;
  //   }

  //   // Builds the options list.
  //   let arr = new Array();
  //   for (var i = 0; i < el.options.length; i++) {
  //     arr[i] = new Array();
  //     arr[i][0] = el.options[i].text;
  //     arr[i][1] = el.options[i].value;
  //   }

  //   // Allows sortVal to be optional, defaults to text.
  //   switch (sortVal) {
  //     case 'value': // sort by value
  //       sortVal = 1;
  //       break;
  //     default:
  //       // sort by text
  //       sortVal = 0;
  //   }

  //   arr.sort((a, b) => {
  //     return a[sortVal] == b[sortVal] ? 0 : a[sortVal] < b[sortVal] ? -1 : 1;
  //   });

  //   // Removes all options from the select.
  //   while (el.options.length > 0) {
  //     el.options[0] = null;
  //   }

  //   // Recreates all options with the new order.
  //   for (var i = 0; i < arr.length; i++) {
  //     var op = new Option(arr[i][0], arr[i][1]);
  //     el.options[i] = op;
  //   }

  //   return true;
  // },

  // Requires `smoothscroll.js` polyfill for unsupported browsers: http://iamdustan.com/smoothscroll/
  // scrollTo: function (el, options) {
  //   options = options || {};

  //   if (el.length === 0) return;

  //   let defaults = {
  //     offset: 0,
  //     pushHash: true,
  //   };

  //   options = util.deepExtend(defaults, options);

  //   let hash = el.getAttribute('href');

  //   if (hash !== '#') {
  //     let target = document.querySelector(hash);

  //     if (!target) {
  //       target = document.querySelector(
  //         'a[name="' + hash.replace('#', '') + '"]'
  //       );
  //     }

  //     if (!target) return;

  //     target.scrollIntoView({
  //       behavior: 'smooth',
  //     });

  //     let elementPosition = target.offsetTop;
  //     let offsetPosition = elementPosition - options.offset;

  //     window.scrollTo({
  //       top: offsetPosition,
  //       behavior: 'smooth',
  //     });

  //     if (options.pushHash) {
  //       window.location.hash = hash.replace('#', '');
  //     }
  //   }
  // },

  // Use `insertBefore` instead of `appendChild`: https://www.paulirish.com/2011/surefire-dom-element-insertion/
  // injectFile: function (path, type, ref) {
  //   if (type == 'js') {
  //     let el = document.createElement('script');
  //     el.setAttribute('type', 'text/javascript');
  //     el.setAttribute('src', path);
  //     placeholder.parentNode.insertBefore(el, ref);
  //   } else if (type == 'css') {
  //     let el = document.createElement('link');
  //     el.setAttribute('rel', 'stylesheet');
  //     el.setAttribute('type', 'text/css');
  //     el.setAttribute('href', path);
  //     placeholder.parentNode.insertBefore(el, ref);
  //   }
  // },

  // https://www.freecodecamp.org/news/javascript-debounce-example/
  debounce: function (func, timeout) {
    timeout = timeout || 250;

    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  },

  debounceLeading: function (func, timeout) {
    timeout = timeout || 250;

    let timer;
    return (...args) => {
      if (!timer) {
        func.apply(this, args);
      }

      clearTimeout(timer);
      timer = setTimeout(() => {
        timer = undefined;
      }, timeout);
    };
  },

  addGlobalEventListener: function (type, selector, callback) {
    document.addEventListener(type, (event) => {
      if (event.target.matches(selector)) callback(event);
    });
  },

  getVideoEmbedHtmlFromUrl: function (url) {
    const youTubeRegex =
      /https?:\/\/.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/|watch\/|live\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?\/]*).*/i;
    const vimeoRegex =
      /https?:\/\/(?:www.)?vimeo.com\/(?:channels\/(?:w+\/)?|groups\/(?:[^\/]*)\/videos\/|)(\d+)(?:|\/?)/i;

    const youTubeMatch = youTubeRegex.exec(url);
    const vimeoMatch = vimeoRegex.exec(url);

    // YouTube
    if (youTubeMatch && youTubeMatch.length >= 2) {
      return (
        '<iframe width="1280" height="720" src="https://www.youtube-nocookie.com/embed/' +
        youTubeMatch[1] +
        '?rel=0&autoplay=1&showinfo=0&vq=hd1080" frameborder="0" allow="autoplay; fullscreen; accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
      );
    }

    // Vimeo
    if (vimeoMatch && vimeoMatch.length >= 2) {
      return (
        '<iframe width="1280" height="720" src="https://player.vimeo.com/video/' +
        vimeoMatch[1] +
        '?autoplay=1&dnt=1&quality=1080p" frameborder="0" allow="autoplay; fullscreen; accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
      );
    }

    return '';
  },

  slideUp: function (target, duration, cb) {
    duration = duration || 500;

    target.style.transitionProperty = 'height, margin, padding, opacity';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';

    window.setTimeout(() => {
      target.style.overflow = 'hidden';
      target.style.opacity = 0;
      target.style.height = 0;
      target.style.paddingTop = 0;
      target.style.paddingBottom = 0;
      target.style.marginTop = 0;
      target.style.marginBottom = 0;

      window.setTimeout(() => {
        target.style.display = 'none';
        target.style.visibility = 'hidden';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
        target.style.removeProperty('box-sizing');
        target.style.removeProperty('opacity');
      }, duration);
    }, 10);

    if (typeof cb === 'function') {
      window.setTimeout(cb, duration + 10);
    }
  },

  slideDown: function (target, duration, cb) {
    duration = duration || 500;

    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    if (display === 'none') display = 'block';
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.opacity = 0;
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.style.boxSizing = 'border-box';

    window.setTimeout(() => {
      target.style.transitionProperty = 'height, margin, padding, opacity';
      target.style.transitionDuration = duration + 'ms';
      target.style.height = height + 'px';
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      target.style.opacity = 1;
      target.style.visibility = 'visible';

      window.setTimeout(() => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
      }, duration);
    }, 10);

    if (typeof cb === 'function') {
      window.setTimeout(cb, duration + 10);
    }
  },

  slideToggle: function (target, duration, cb) {
    duration = duration || 500;

    if (window.getComputedStyle(target).display === 'none') {
      return slideDown(target, duration, cb);
    } else {
      return slideUp(target, duration, cb);
    }
  },

  areEqualArrays: function (first, second) {
    if (first.length !== second.length) {
      return false;
    }
    for (let i = 0; i < first.length; i++) {
      if (second.includes(first[i]) === false) {
        return false;
      }
    }
    return true;
  },

  scrollContainerTo: function (container, target, offset) {
    if (container.contains(target)) {
      offset = typeof offset === 'number' ? offset : 0;
      container.scrollTo({
        top: target.offsetTop - offset,
        behavior: 'smooth',
      });
    } else {
      throw 'scrollContainerTo Error: target not found in container';
    }
  },

  isKeyboardEvent: function (event) {
    return event instanceof KeyboardEvent || (event.clientX === 0 && event.clientY === 0);
  },

  hasCookieConsent: function (category) {
    return util.getCookie('cookieconsent_' + category) === 'accepted';
  },

  updateCookieConsent: function (consents) {
    if (!consents) return;
    if (typeof ccPopup === 'undefined') return;

    if (consents.indexOf('analytics') > -1) {
      ccPopup.acceptCategory('analytics');
    }

    if (consents.indexOf('marketing') > -1) {
      ccPopup.acceptCategory('marketing');
    }

    if (consents.indexOf('preferences') > -1) {
      ccPopup.acceptCategory('preferences');
    }
  },

  invariantEquals: function (a, b) {
    return a.toLowerCase().trim() === b.toLowerCase().trim();
  },

  // Force a browser re-paint so the browser will realize the
  // element is no longer `hidden` and allow transitions.
  reflow: function (element) {
    return element.offsetHeight;
  },
};

/* ========================================================================
   Use module pattern to encapsulate JavaScript: http://bit.ly/2jM4ptd
   Define custom namespace
 ========================================================================== */

let app = {};
